import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ColDef, GridApi, GridReadyEvent, RowNode } from 'ag-grid-community';
import { toNumber } from 'lodash';
import { Subscription } from 'rxjs';
import { BodisplayComponent } from '../../../../../bodisplay';
import { CustomGridService } from '../../../../../customgrid';
import { Apprenant, BlockTree, BObjectModel, BreadDik, EventsModel, Person, QResult, QueovalDateTime, QueovalParam } from '../../../../../models';
import { PlanningFormationModel } from '../../../../../models/formation';
import { EtatPresence, FilterPlanning, LearnerPresence, PlanningOnglet, ReservationForUpdate, ReservationPlanning, ReservationPlanningAndIdStage } from '../../../../../models/formation/planning.model';
import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { isEmptyStr } from '../../../../../utilities';
import { StageService } from '../../services/stage-modal.service';
import { PlanningService } from '../planning.service';





@Component({
  selector: 'q-liste-reservations',
  templateUrl: './liste-reservations.component.html',
  styleUrls: ['./liste-reservations.component.css'],
})

export class ListeReservationComponent implements OnInit {

  @Input('type') set SetType(value: PlanningOnglet) {
    this.CodeOnglet = value;
  }


  // #region Filtres

  /**
   * Liste des réservations filtrées
   */
  // public ListReservFilter: Array<ReservationPlanning>;

  @Input('selectAll') set SetSelectAll(value: boolean) {
    if (this.planningService.Filter) {
      this.planningService.ListeReservationsFilter.forEach(reserv => {
        if (!this.planningService.ShowOnlyNewReservState || reserv && reserv.Ident == "0")
          reserv.IsSelected = value;
      });
      for (var i = 0; i < this.planningService.nbReservShowed; i++) {
        if (this.planningService.sortedReservations[i] != this.planningService.ListeReservationsFilter[i]) {
          if (!this.planningService.ShowOnlyNewReservState || this.planningService.ListeReservationsFilter[i].Ident == "0") {
            this.planningService.sortedReservations[i] = this.planningService.ListeReservationsFilter[i];
          }
        }
      }
    }
    if (value) {
      this.SetListChecked();
    }

  }

  // #endregion



  public CodeOnglet: number;

  // #region Mode visualisation en custom grid

  @Input('displayMode') set SetDisplayMode(value: boolean) {
    this.isCustomGrid = value;
    if (this.isCustomGrid) {
      this.OnSearchCustomgrid();
    }
    else {
      this.planningService.RefreshReserv();
    }
  }

  public customgridPresenceFileName: string = "ListeReservationPresenceFiltre";
  public customgridPlanningFileName: string = "ListeReservationPlanningFiltre";

  public customgridWhere: string;
  public isCustomGrid: boolean;
  public param: QueovalParam;

  public gridPlanningObserver: Subscription;
  public gridPresenceObserver: Subscription;

  public refreshPresenceData: boolean = false;
  public refreshPlanningData: boolean = false;

  public extendedDeleteMessage: string = '';
  // #endregion


  public ReservSelected: ReservationPlanning;

  /* modal ou ouvrir le bo*/

  @ViewChild('ModalUpdateDuree', { static: false }) ModalUpdateDuree: ElementRef;
  @ViewChild('ModalReservationGrid', { static: false }) ModalReservationGrid: ElementRef;
  @ViewChild('ModalBO', { static: false }) ModalBO: ElementRef;

  @ViewChild('bodisplay', { static: false }) BoDisplay: BodisplayComponent;

  @ViewChild('filter', { static: false }) filterContainer: ElementRef;


  public boModel: BObjectModel = new BObjectModel();
  public getBo: boolean = false;

  public isLoading: boolean = false;
  public editLoading: boolean = false;

  public HeuresStages: number = 0;
  public refreshCount: number = 0;


  /**
   * Liste des réservations cochées
   */
  public ListReservChecked: Array<ReservationPlanning>;
  public ReservForUpdate: ReservationForUpdate;

  public apprenantsForUpdate: Array<Apprenant> = [];

  public planningOnglet: typeof PlanningOnglet = PlanningOnglet;
  public etatPresence: typeof EtatPresence = EtatPresence;


  // Liste des apprenants (pour les présences)
  public deletingSignature: boolean = false;
  public listApprenant: Array<Apprenant>;
  public globalPresence: string = '';
  public globalPresenceMulti: string = '';
  public savingPresence: boolean = false;
  public reloadEmargementFormateur: boolean = false;

  public newReservRefresh: ReservationPlanning | undefined;
  public newDureeHeure: string;

  public gridItem: Subscription;
  public gridAPI: GridApi;

  constructor(
    public stageService: StageService,
    public planningService: PlanningService,
    private http: HttpService,
    private indParam: CoreService,
    protected modalservice: NgbModal,
    protected queovalDateService: QueovalDateService,
    private toast: ToastService,
    protected customgridservice: CustomGridService,
    public sanitize: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    this.planningService.ViewChange.subscribe((value: PlanningOnglet) => {
      if (value == PlanningOnglet.SuiviPresence) {
        const reserv = this.planningService.ListeReservations.find(reserv => reserv.IsEdit);
        if (reserv) {
          this.openSuiviPresence(reserv, true);
        }
      }
    });
  }


  public ngOnInit(): void {
    this.ReservForUpdate = new ReservationForUpdate();
    this.stageService.GetNbHoursStage().subscribe((result: QResult<number>) => this.HeuresStages = result.Value);
    this.stageService.GetApprenantsByStageList().subscribe((result: QResult<Array<Apprenant>>) => this.apprenantsForUpdate = result.Value);
    this.InitGrid();
  }

  ngOnDestroy(): void {
    if (this.gridItem) {
      this.gridItem.unsubscribe();
    }
    if (this.gridPlanningObserver) {
      this.gridPlanningObserver.unsubscribe();
    }
    if (this.gridPresenceObserver) {
      this.gridPresenceObserver.unsubscribe();
    }

  }

  public OnGridReady(event: GridReadyEvent): void {
    this.gridAPI = event.api;
  }
  public showGroup(groupe: BlockTree) {
    groupe.IsVisible = !groupe.IsVisible;
  }

  // #region Gestion de la vue en mode custom grid des reservations
  /**
  * Initialise la grid 
  * */
  private InitGrid(): void {
    this.gridPlanningObserver = this.customgridservice.getItem(this.customgridPlanningFileName).subscribe((res: BObjectModel) => {
      this.ActionGrid(res);
    });
    this.gridPresenceObserver = this.customgridservice.getItem(this.customgridPresenceFileName).subscribe((res: BObjectModel) => {
      this.ActionGrid(res);
    });
  }

  private ActionGrid(model: BObjectModel) {

    switch (model.Action) {

      case 'ANG_PAGE':
        if (model.IdDonneeFils && model.IdDonneeFils != '0') {
          this.param = new QueovalParam();
          model.ShowRemoveButton = true;
          model.ShowSaveButton = true;
          model.ShowZoomButton = false;
          model.ShowCreateButton = false;
          model.ShowImportButton = false;
          model.CodeRelation = "REL_BO_STAGE_BO_RESERV";
          model.Mode
          this.param.model = JSON.parse(JSON.stringify(model));
          this.param.params.push({ key: 'code', value: `RESA` });
          this.modalservice.open(this.ModalReservationGrid, { size: 'q-xxl', centered: true, windowClass: 'qmodalover modal-reservation_grid' });
        }
        break;
    }
  }

  public OnSearchCustomgrid() {
    // Ident du stage
    this.customgridWhere = `L0.Pere_LIE = ${this.stageService.Stage.Ident} `;
    // Plage de date pour la date de debut de la reservation
    // Du
    if (this.planningService.Filter.DateDebut) {
      this.customgridWhere += ` AND eve.DatefEVE >= '${this.queovalDateService.ToString(this.planningService.Filter.DateDebut, 'yyyy-dd-MM')} 00:00:00'`;
    }
    // Au
    if (this.planningService.Filter.DateFin) {
      this.customgridWhere += ` AND eve.DatedEVE <= '${this.queovalDateService.ToString(this.planningService.Filter.DateFin, 'yyyy-dd-MM')} 23:59:59'`;
    }
    // Liste des formateurs selectionnes
    if (this.planningService.Filter.Formateurs.length > 0) {
      let filterFormateur: Array<string> = [];
      this.planningService.Filter.Formateurs.forEach((form: Person) => {
        filterFormateur.push(form.Id);
      });
      this.customgridWhere += ` AND ( L1.Pere_LIE in (${filterFormateur.join(',')}) OR L1.Pere_LIE IS NULL ) `;
    }
    else {
      this.customgridWhere += ' AND L1.Pere_LIE IS NULL ';
    }
    if (this.planningService?.View == this.planningOnglet.Planning)
      this.refreshPlanningData = true;
    else
      this.refreshPresenceData = true;
  }

  public goBack(): void {
    if (this.planningService?.View == this.planningOnglet.Planning)
      this.refreshPlanningData = true;
    else
      this.refreshPresenceData = true;

  }

  // #endregion

  // Liste des elements selectionnés pour le tooltip
  public GetListElement(listElementLinked: Array<Person>): string {
    let elements: string = '';
    if (listElementLinked) {
      listElementLinked.forEach((item: Person) => {
        elements = item && item.Value ? elements ? `${elements}\n${item.Value}` : item.Value : elements;
      });
    }
    return elements;
  }

  /**
   * Initialisation de l'objet de mise à jour des réservations (remise à zéro des valeurs)
   **/
  public InitReservForUpdate(): void {
    // this.ReservForUpdate = new ReservationForUpdate();
    this.ReservForUpdate.Formateurs = [];
    this.ReservForUpdate.ObjetReserves = JSON.parse(JSON.stringify(this.planningService.Objets));
    this.ReservForUpdate.IdLieu = '';
    this.ReservForUpdate.IdBureau = '';
    this.ReservForUpdate.CodeDispo = '';
  }

  public GetListIdForm(reserv: ReservationPlanning): Array<string> {
    return reserv.Formateurs.map(x => x.Id);
  }

  public SetFormateurList(reserv: ReservationPlanning, lstFormateur: Array<Person>): void {
    reserv.Formateurs = lstFormateur;
    // Enregistrement en bdd si id de la reserv != 0
    if (reserv.Ident && reserv.Ident != '0') {
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SET_FORMATEUR_LIST`, reserv).subscribe(() => {/*this.RefreshReserv()*/ });
    }
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
* 
* @param Modal la modal qui doit être ouverte
* @param xl si oui la modal est grande, sinon elle est de taille réduite
*/
  public open(Modal: any, xl: boolean = true) {
    if (xl) {
      this.modalservice.open(Modal, { centered: true, size: 'lg', windowClass: 'qmodalover' });
    } else {
      this.modalservice.open(Modal, { centered: true, windowClass: 'qmodalover' });
    }
  }

  public OpenEditPresence(Modal: any): void {
    this.globalPresenceMulti = '';
    this.apprenantsForUpdate.forEach(app => app.presence = '');
    this.modalservice.open(Modal, { centered: true, size: 'lg', windowClass: 'qmodalover' }).result.finally(() => {
      if (this.planningService.ListeReservations.some(reserv => reserv.IsEdit)) {
        this.isLoading = false;
        this.http.getHttp<QResult<Array<Apprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_APPRENANTS_PRESENCE/${this.planningService.idReserv}|${this.stageService.Stage.Ident}`).subscribe((result: QResult<Array<Apprenant>>) => {
          this.listApprenant = result.Value;
          this.isLoading = false;
          this.initGlobalPresence(this.globalPresenceMulti)
        });
      }
    });
  }

  /**
   * Ouverture de la modale de suppression d'une réservation
   * @param reserv
   */
  public openDeleteOne(reserv: ReservationPlanning, Modal: any): void {
    if (reserv.NbPresent > 0 || reserv.NbPreinsc > 0 || reserv.NbAbs > 0 || reserv.NbAbsInj > 0) {
      this.extendedDeleteMessage = 'Vous êtes sur le point de supprimer une réservation sur laquelle il existe des états de présence.';
    } else {
      this.extendedDeleteMessage = '';
    }
    this.ReservSelected = reserv;
    this.modalservice.open(Modal, { centered: true, windowClass: 'qmodalover' });
  }

  public SetExtendedDeleteMessage(reservations: ReservationPlanning[]) {
    this.extendedDeleteMessage = '';
    if (reservations.some(resa => {
      return resa.IsSelected && (resa.NbPresent > 0 || resa.NbPreinsc > 0 || resa.NbAbs > 0 || resa.NbAbsInj > 0);
    })) {
      if (reservations.length > 1) {
        this.extendedDeleteMessage = 'Vous êtes sur le point de supprimer des réservations sur lesquelles il existe des états de présence.';
      }
      else {
        this.extendedDeleteMessage = 'Vous êtes sur le point de supprimer une réservation sur laquelle il existe des états de présence.';
      }
    }
  }

  // #region DELETE

  /*
  * Supprimer les réservations selectionnées
  */
  public DeleteReserv() {
    let lstReservToDelete: Array<ReservationPlanning> = [];
    for (var i = 0; i < this.planningService.ListeReservations.length; i++) {
      if (this.planningService.ListeReservations[i].IsSelected) {
        // Si c'est une réservation temporaire -> suppression manuellement dans la liste
        if (!this.planningService.ListeReservations[i].Ident || this.planningService.ListeReservations[i].Ident == '0') {
          this.planningService.ListeReservations.splice(i, 1);
          i--;
        }
        else {
          // Ajout à la liste qui va être supprimée en base
          lstReservToDelete.push(this.planningService.ListeReservations[i]);
        }
      }
    }


    const msgSuccessToast = "Les réservations ont bien été supprimées";
    if (lstReservToDelete.length > 0) {
      const model: ReservationPlanningAndIdStage = {
        IdStage: this.stageService.Stage.Ident,
        reservations: lstReservToDelete
      }
      this.http.postHttp<QResult<Array<ReservationPlanning>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/DELETE_RESERVATIONS`, model).subscribe(
        (result: QResult<Array<ReservationPlanning>>) => {
          if (!result.HasError) {
            this.planningService.ListeReservations = result.Value;

            let indexTodelete: number[] = []
            for (var i = 0; i < this.planningService.sortedReservations.length; i++) {
              if (this.planningService.ListeReservationsFilter[i] != this.planningService.sortedReservations[i]) {
                if (this.planningService.ListeReservationsFilter[i]) {
                  this.planningService.sortedReservations[i] = this.planningService.ListeReservationsFilter[i];
                } else {
                  indexTodelete.push(i);
                }
              }
            }

            indexTodelete.sort((a, b) => b - a);
            indexTodelete.forEach(i => {
              this.planningService.sortedReservations.splice(i, 1);
            });

            this.toast.showSuccessToast(msgSuccessToast);
          }

          //this.planningService.Filter.IndeterminateSelect = false;
          //this.planningService.isSelectAll = false;
          this.planningService.OnRefreshDisplay();
        });
    }
    else {
      this.toast.showSuccessToast(msgSuccessToast);
      //this.planningService.ListeReservations = JSON.parse(JSON.stringify(this.planningService.ListeReservations));

      let cptNewReserv: number = this.planningService.ListeReservationsFilter.filter(r => r.Ident == "0").length;
      let cptReserv: number = this.planningService.sortedReservations.filter(r => r.Ident != "0").length;

      if ((this.planningService.ShowOnlyNewReservState || cptReserv == 0) && cptNewReserv > 0) { // La suppression ne se voit pas sur ListereservFilter
        let j: number = 0;
        let indexTodelete: number[] = []
        for (var i = 0; i < this.planningService.nbReservShowed; i++) {
          if (this.planningService.ListeReservationsFilter[i] && this.planningService.ListeReservationsFilter[i].Ident == "0" && this.planningService.ListeReservationsFilter[i] != this.planningService.sortedReservations[i]) {
            this.planningService.sortedReservations[j] = this.planningService.ListeReservationsFilter[i];
            j++;
          } else {
            indexTodelete.push(i);
          }
        }

        indexTodelete.sort((a, b) => b - a);
        indexTodelete.forEach(i => {
          this.planningService.sortedReservations.splice(i, 1);
        });

      } else {
        //this.planningService.OnRefreshDisplay();
        this.planningService.ShowOnlyNewReservState = false;
      }


      //if (this.planningService.ListeReservationsFilter.length <= this.planningService.nbReservOffset) {
      //  this.planningService.displayShowMore = false;
      //} else {
      //  this.planningService.displayShowMore = true;
      //}

      //this.planningService.Filter.IndeterminateSelect = false;
      //this.planningService.isSelectAll = false;
      this.planningService.ListeReservationsFilter.forEach(e => e.IsSelected = false);

      this.planningService.OnRefreshDisplay();
    }
  }

  /*
  * Supprimer une réservation
  */
  public DeleteOneReserv() {
    const model: ReservationPlanningAndIdStage = {
      IdStage: this.stageService.Stage.Ident,
      reservations: []
    };
    model.reservations.push(this.ReservSelected);
    this.http.postHttp<QResult<Array<ReservationPlanning>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/DELETE_RESERVATIONS`, model).subscribe(
      (result: QResult<Array<ReservationPlanning>>) => {
        if (!result.HasError) {
          this.toast.showSuccessToast('La réservation a bien été supprimée');
          const tempsReservations = this.planningService.ListeReservations.filter(reservation => !reservation.Ident || reservation.Ident == "0");
          this.planningService.ListeReservations = tempsReservations.concat(result.Value);
          this.planningService.OnRefreshDisplay();
        }
      });

  }

  // #endregion


  /**
   * Sélection d'un bureau
   * @param idBureau
   * @param reserv
   */
  public SelectBureau(idBureau: string, reserv: ReservationPlanning): void {
    reserv.IdBureau = idBureau;
    // Enregistrement en bdd si id de la reserv != 0
    if (reserv.Ident && reserv.Ident != '0') {
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SET_BUREAU`, reserv).subscribe();
    }

  }

  /**
   * Sélection d'un lieu de convocation
   * @param idLieau
   * @param reserv
   */
  public SelectLieu(idLieu: string, reserv: ReservationPlanning): void {
    reserv.IdLieu = idLieu;
    // Enregistrement en bdd si id de la reserv != 0
    if (reserv.Ident && reserv.Ident != '0') {
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SET_LOCATION`, reserv).subscribe();
    }
  }

  /**
   * Sélection d'une disponibilité (pour l'enregistrement massif)
   * @param codeDispo
   * @param reserv
   */
  public SelectDispo(codeDispo: string, reserv: ReservationPlanning): void {
    reserv.CodeDispo = codeDispo;
  }

  // #region BO

  /**
   * Ouverture du BO en pop-up
   * @param reserv
   */
  public openBo(reserv: ReservationPlanning): void {
    this.ReservSelected = reserv;
    // Ouverture du BO si l'ident existe sinon ouverture du temporaire
    if (this.ReservSelected.BoReserv && this.ReservSelected.BoReserv.IdDonneeFils && this.ReservSelected.BoReserv.IdDonneeFils != '0') {
      this.modalservice.open(this.ModalBO, { centered: true, size: 'lg', windowClass: 'qmodalover' });
    }
    else {
      this.planningService.boParam = new QueovalParam();
      this.planningService.boParam.params = [new BreadDik('isLoaded', true)];
      this.planningService.boParam.model = reserv.BoReserv;
      this.boModel = JSON.parse(JSON.stringify(reserv.BoReserv))
      this.modalservice.open(this.ModalBO, { centered: true, size: 'lg', windowClass: 'qmodalover' }).result.then((result) => {
        switch (result) {
          case 'SAVE': break;
          default:
            this.planningService.boParam.model = JSON.parse(JSON.stringify(this.boModel));
            break;
        }
      }).catch((result) => {
        switch (result) {
          case 'SAVE': break;
          default:
            this.planningService.boParam.model = JSON.parse(JSON.stringify(this.boModel));
            break;
        }
      });

    }

  }

  /**
   * Ouverture du BO en dessous
   * @param reserv
   */
  public openBoUnder(reserv: ReservationPlanning): void {
    this.closeAllEdit();
    this.planningService.idReserv = reserv.Ident;

    //  this.ReservSelected = reserv;
    // Ouverture du BO si l'ident existe sinon ouverture du temporaire
    if (reserv.BoReserv && reserv.BoReserv.IdDonneeFils && reserv.BoReserv.IdDonneeFils != '0') {
      reserv.IsEdit = true;
    }
    else {
      this.planningService.boParam = new QueovalParam();
      this.planningService.boParam.params = [new BreadDik('isLoaded', true)];
      this.planningService.boParam.model = reserv.BoReserv;
      // this.boModel = JSON.parse(JSON.stringify(reserv.BoReserv));
      reserv.IsEdit = true;
    }
  }



  /**
   * Fermeture de la zone BO / suivi présence sous la reservation
   * @param reserv
   */
  public closeEdit(reserv: ReservationPlanning): void {
    reserv.IsEdit = false;
  }

  /**
   * Rafraichissement de la liste des réservation après enregistrement / suppression
   **/
  public RefreshReserv(pReserv: ReservationPlanning): void {
    // ToDo: Appel serveur pour déclancher le workflow scenario BO_RESERV_UPDATE si la reservation existe

    // Rafraichissement de la liste des réservation
    this.http.getHttp<QResult<PlanningFormationModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/REFRESH_LIST_RESERV/${this.stageService.Stage.Ident}`).subscribe
      ((result: QResult<PlanningFormationModel>) => {
        if (pReserv.Ident) {
          if (pReserv.Ident != '0') {
            this.planningService.ListeReservations = result.Value.ListeReservations;

            this.newReservRefresh = result.Value.ListeReservations.find(reserv => reserv.Ident == pReserv.Ident);
            if (this.newReservRefresh && this.queovalDateService.Compare(this.newReservRefresh.DateFin, '>', this.planningService.Filter.DateFin)) {
              this.planningService.Filter.DateFin = this.newReservRefresh.DateFin;
            }

            for (var i = 0; i < this.planningService.nbReservShowed; i++) {
              if (this.planningService.sortedReservations[i] != this.planningService.ListeReservationsFilter[i]) {
                Object.assign(this.planningService.sortedReservations[i], this.planningService.ListeReservationsFilter[i]);
              }
            }

            // mise à jour de la durée
            if (this.newReservRefresh) {
              const dtFin: Date | null = this.queovalDateService.ToDateTime(this.newReservRefresh.DateFin);
              const dtDebut: Date | null = this.queovalDateService.ToDateTime(this.newReservRefresh.DateDebut);
              if (dtFin != null && dtDebut != null) {
                const duree: any = dtFin.getTime() - dtDebut.getTime();
                const heures: number = Math.round(duree / 1000 / 60 / 60);
                const minutes: number = Math.round(duree / 1000 / 60 - heures * 60);
                this.newDureeHeure = (duree / 1000 / 60 / 60).toFixed(2).replace('.', ',');

                if (this.newReservRefresh.Duree != this.newDureeHeure) {
                  console.log(`Duree ${this.newReservRefresh.Duree} nouvelle duree ${this.newDureeHeure}`);
                  this.modalservice.open(this.ModalUpdateDuree, { centered: true, windowClass: 'qmodalover' });
                }


              }
            }

          } else {
            this.planningService.sortedReservations.sort((a, b) => {
              const aDate = this.queovalDateService.ToDate(a.DateDebut);
              const bDate = this.queovalDateService.ToDate(b.DateDebut);

              if (aDate && bDate) {
                return aDate.getTime() - bDate.getTime();
              }

              return 0;
            });
          }
        }
        //pReserv.IsEdit = false;
      });
  }

  public UpdateReserv(): void {
    if (this.newReservRefresh) {

      this.newReservRefresh.Duree = this.newDureeHeure;
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SAVE_RESERVATION`, this.newReservRefresh).subscribe(() => { /*this.RefreshReserv()*/ });

      for (var i = 0; i < this.planningService.nbReservShowed; i++) {
        if (this.planningService.sortedReservations[i] != this.planningService.ListeReservationsFilter[i]) {
          Object.assign(this.planningService.sortedReservations[i], this.planningService.ListeReservationsFilter[i]);
        }
      }
    }

  }

  public OnGetBo(pBoModel: BObjectModel, reservSelected: ReservationPlanning): void {

    let selectedReserv = this.planningService.ListeReservations.find(reserv => {
      return (
        this.queovalDateService.Compare(reserv.DateDebut, '=', reservSelected.DateDebut)
        && reserv.DateDebut.heures == reservSelected.DateDebut.heures
        && reserv.DateDebut.minutes == reservSelected.DateDebut.minutes

        && this.queovalDateService.Compare(reserv.DateFin, '=', reservSelected.DateFin)
        && reserv.DateFin.heures == reservSelected.DateFin.heures
        && reserv.DateFin.minutes == reservSelected.DateFin.minutes

        && reserv.Ident == '0'
      )
    });
    if (selectedReserv) {
      selectedReserv.BoReserv = pBoModel;
      const summTitre = pBoModel.summary.find(s => s.ColumnName.toLowerCase() == 'objeteve');
      const summDateDebut = pBoModel.summary.find(s => s.ColumnName.toLowerCase() == 'datedeve');
      const summDateFin = pBoModel.summary.find(s => s.ColumnName.toLowerCase() == 'datefeve');
      const summDuree = pBoModel.summary.find(s => s.ColumnName.toLowerCase() == 'dureeeve');
      if (summTitre) {
        selectedReserv.Titre = pBoModel.Body.SelectedGroupsList[summTitre.IndexGroupsList].DataList[summTitre.IndexDataList].MainElementList[0].Value;
      }

      if (summDateDebut) {
        if (summDateDebut.CountMainElementList > 2) {

          const mainELDtDeb = pBoModel.Body.SelectedGroupsList[summDateDebut.IndexGroupsList].DataList[summDateDebut.IndexDataList].MainElementList;
          let strJourDebut = mainELDtDeb[0].Value;
          let strHeureDebut: string = '';
          let optionSelectedDtDebHr = mainELDtDeb[1].SelectOptionsList.find(opt => opt.Selected);
          if (optionSelectedDtDebHr) {
            strHeureDebut = optionSelectedDtDebHr.Value;
          }
          let strMinuteDebut: string = '';
          let optionSelectedDtDebMin = mainELDtDeb[2].SelectOptionsList.find(opt => opt.Selected);
          if (optionSelectedDtDebMin) {
            strMinuteDebut = optionSelectedDtDebMin.Value;
          }

          let qJourDeb = this.queovalDateService.FromString(strJourDebut, 'dd/MM/yyyy');
          selectedReserv.DateDebut = new QueovalDateTime(qJourDeb.annee, qJourDeb.mois, qJourDeb.jour, strHeureDebut, strMinuteDebut);
          let dtDebut = this.queovalDateService.ToDate(selectedReserv.DateDebut);
          const weekday = ["DIM.", "LUN.", "MAR.", "MER.", "JEU.", "VEN.", "SAM."];
          let numDay = dtDebut?.getDay();
          if (numDay) {
            selectedReserv.JourSemaine = weekday[numDay];
          }

          const strShortDate = dtDebut?.toLocaleDateString('fr-FR', { year: "numeric", month: 'long', day: 'numeric' });
          if (strShortDate) {
            selectedReserv.ShortDate = strShortDate;
          }
        }
      }
      if (summDateFin) {
        if (summDateFin.CountMainElementList > 2) {

          const mainELDtFin = pBoModel.Body.SelectedGroupsList[summDateFin.IndexGroupsList].DataList[summDateFin.IndexDataList].MainElementList;
          let strJourFin = mainELDtFin[0].Value;
          let strHeureFin: string = '';
          let optionSelectedDtFinHr = mainELDtFin[1].SelectOptionsList.find(opt => opt.Selected);
          if (optionSelectedDtFinHr) {
            strHeureFin = optionSelectedDtFinHr.Value;
          }
          let strMinuteFin: string = '';
          let optionSelectedDtFinMin = mainELDtFin[2].SelectOptionsList.find(opt => opt.Selected);
          if (optionSelectedDtFinMin) {
            strMinuteFin = optionSelectedDtFinMin.Value;
          }

          let qJourFin = this.queovalDateService.FromString(strJourFin, 'dd/MM/yyyy');
          selectedReserv.DateFin = new QueovalDateTime(qJourFin.annee, qJourFin.mois, qJourFin.jour, strHeureFin, strMinuteFin);

          let dtFin = this.queovalDateService.ToDate(selectedReserv.DateFin);
          const strShortDateEnd = dtFin?.toLocaleDateString('fr-FR', { year: "numeric", month: 'long', day: 'numeric' });
          if (strShortDateEnd) {
            selectedReserv.ShortDateEnd = strShortDateEnd;
          }
        }
      }
      if (summDuree) {
        selectedReserv.Duree = pBoModel.Body.SelectedGroupsList[summDuree.IndexGroupsList].DataList[summDuree.IndexDataList].MainElementList[0].Value;
      }

      // type en fonction des heures de début & fin
      if (selectedReserv.DateDebut && selectedReserv.DateFin) {
        if (selectedReserv.DateDebut.jour == selectedReserv.DateDebut.jour && selectedReserv.DateDebut.mois == selectedReserv.DateDebut.mois && selectedReserv.DateDebut.annee == selectedReserv.DateDebut.annee) {
          let heurDeb: number = parseInt(selectedReserv.DateDebut.heures);
          let heurFin: number = parseInt(selectedReserv.DateFin.heures);
          if (heurFin < 13) {
            selectedReserv.TypeReserv = 'Matin';
          }
          else if (heurDeb > 12) {
            selectedReserv.TypeReserv = 'Après midi';
          }
          else {
            selectedReserv.TypeReserv = 'Journée';
          }
        }
        else {
          selectedReserv.TypeReserv = 'Intervalle';
        }
      }

    }
  }

  // #endregion

  // #region Objets Sélectionnés

  public OneObjectSelected(reserv: ReservationPlanning): boolean {
    if (!reserv.ObjetReserves || !reserv.ObjetReserves.Children || reserv.ObjetReserves.Children.length == 0)
      return false;
    let result: boolean = false;
    let nbSelected: number = 0;
    for (let i: number = 0; i < reserv.ObjetReserves.Children.length; i++) {
      nbSelected += reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked).length;
    }
    if (nbSelected == 1) {
      result = true;
    }
    return result;
  }

  public NumberObjectSelected(reserv: ReservationPlanning): number {
    let result: number = 0;
    for (let i: number = 0; i < reserv.ObjetReserves.Children.length; i++) {
      result += reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked).length;
    }
    return result;
  }

  public AnyObjectSelected(reserv: ReservationPlanning): boolean {
    if (!reserv.ObjetReserves || !reserv.ObjetReserves.Children || reserv.ObjetReserves.Children.length == 0)
      return false;
    let result: boolean = false;
    for (let i: number = 0; i < reserv.ObjetReserves.Children.length; i++) {
      if (reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked).length > 0) {
        result = true;
        break;
      }
    }
    return result;
  }

  /*
   * Récupération du titre du groupe de l'objet sélectionné
   */
  public GetSelectedGroup(reserv: ReservationPlanning): string {
    let group = '';
    for (let i: number = 0; i < reserv.ObjetReserves.Children.length; i++) {
      if (reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked).length > 0) {
        group = reserv.ObjetReserves.Children[i].Text;
        break;
      }
    }
    return group;
  }

  /*
 * Récupération du texte de l'objet sélectionné
 */
  public GetSelectedObject(reserv: ReservationPlanning): string {
    let txtObj = '';
    for (let i: number = 0; i < reserv.ObjetReserves.Children.length; i++) {
      if (reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked).length > 0) {
        txtObj = reserv.ObjetReserves.Children[i].Children.filter(object => object.IsChecked)[0].Text;
        break;
      }
    }
    return txtObj;
  }

  public SetObjectListSelected(reserv: ReservationPlanning): void {
    this.ReservSelected = reserv;

    // rend visible les blocs avec des éléments séléctionnés 
    this.ReservSelected.ObjetReserves?.Children.forEach(groupe => {
      groupe.IsVisible = false;
      if (groupe.Children.some((item) => item.IsChecked)) {
        groupe.IsVisible = true;
      }
    });
  }

  /** @description check/uncheck item from objects
* @return
*/
  public moveItem(itemGroup: BlockTree, item: BlockTree): void {
    item.IsChecked = !item.IsChecked;
    // Si on décoche 1 objet alors le groupe doit être décoché
    if (!item.IsChecked) {
      itemGroup.IsChecked = false;
    }
    // Enregistrement en base (si la réservation a un ident)
    if (this.ReservSelected.Ident && this.ReservSelected.Ident != '0') {
      this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SET_RESERVED_OBJECT`, this.ReservSelected).subscribe(() => { /*this.RefreshReserv()*/ });
    }

  }

  // Liste des elements selectionnés pour le tooltip
  public GetListObject(objectTree: BlockTree): string {
    let elements: string = '';
    if (objectTree.Children && objectTree.Children.length > 0) {
      objectTree.Children.forEach((group: BlockTree) => {
        group.Children.forEach((obj: BlockTree) => {
          elements = obj && obj.IsChecked ? elements ? `${elements}\n${obj.Text}` : obj.Text : elements;
        });
      });
    }
    return elements;
  }

  // #endregion

  // #region Gestion présence

  /**
   * Ouverture des suivis des présences en dessous
   * @param reserv
   */
  public openSuiviPresence(reserv: ReservationPlanning, pReload: boolean = false): void {
    if (!reserv.IsEdit || pReload) {
      this.closeAllEdit();
      this.planningService.idReserv = reserv.Ident;
      this.isLoading = true;
      // Récupération des apprenants avec leurs présences
      this.http.getHttp<QResult<Array<Apprenant>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/GET_APPRENANTS_PRESENCE/${this.planningService.idReserv}|${this.stageService.Stage.Ident}`).subscribe((result: QResult<Array<Apprenant>>) => {
        this.listApprenant = result.Value;
        reserv.IsEdit = true;
        this.isLoading = false;
        this.initGlobalPresence(this.globalPresence)
      });

    }
    else {
      reserv.IsEdit = false;
    }

  }

  /**
   * Mise à jour de toutes les présences des apprenants
   * @param value
   */
  public SetAllPresence(value: string, pMultiReserv: boolean): void {
    if (pMultiReserv) {
      this.globalPresenceMulti = value;
      this.globalPresence = value;
    } else {
      this.globalPresence = value;
    }
    // Appel serveur pour mettre à jour toutes les présences
    // Enregistrement du lien de "présence" pour l'apprenant sur la reservation
    const model: LearnerPresence = {
      IdReserv: pMultiReserv ? this.ListReservChecked.map(reserv => reserv.Ident) : [this.planningService.idReserv],
      IdStage: this.stageService.Stage.Ident,
      IdLearner: 'ALL',
      CodePresence: value
    };
    this.savingPresence = true;
    document.getElementsByTagName('body')[0].classList.add('q-wait');
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SAVE_PRESENCE`, model).subscribe(
      (datas: QResult<Array<ReservationPlanning>>) => {
        if (!datas.HasError) {
          // Mise à jour de la réservation dans la liste
          datas.Value.forEach(data => {
            let reservToUpdate = this.planningService.ListeReservations.find(reserv => reserv.Ident == data.Ident);
            if (reservToUpdate) {
              reservToUpdate.Etat = data.Etat;
              reservToUpdate.NbNa = data.NbNa;
              reservToUpdate.NbPresent = data.NbPresent;
              reservToUpdate.NbAbs = data.NbAbs;
              reservToUpdate.NbAbsInj = data.NbAbsInj;
              reservToUpdate.NbPreinsc = data.NbPreinsc;
            }
          });
          // Mise à jour de la valeur de présence pour tous les apprenants
          if (pMultiReserv) {
            this.apprenantsForUpdate.forEach((appr: Apprenant) => {
              appr.presence = value;
            });
          } else {
            this.listApprenant.forEach((appr: Apprenant) => {
              appr.presence = value;
            });
          }
        }
        //this.planningService.ListeReservations = JSON.parse(JSON.stringify(this.planningService.ListeReservations));
        this.savingPresence = false;
        document.getElementsByTagName('body')[0].classList.remove('q-wait');
      });
  }

  /**
   * Mise à jour de la présence sur un apprenant
   * @param value
   */
  public UpdatePresence(value: string, ListApprenants: Apprenant[], apprenant: Apprenant, pMultiReserv: boolean): void {
    apprenant.presence = value;
    // Si tous les apprenants ont la même valeur de présence : globalPresence prend cette valeur sinon on la remet à null
    if (pMultiReserv) {
      this.globalPresenceMulti = ListApprenants.some(appr => appr.presence != value) ? '' : value;
    } else {
      this.globalPresence = ListApprenants.some(appr => appr.presence != value) ? '' : value;
    }

    // Appel serveur pour mettre à jour la présence de l'apprenant
    // Enregistrement du lien de "présence" pour l'apprenant sur la reservation
    const model: LearnerPresence = {
      IdReserv: pMultiReserv ? this.ListReservChecked.map(reserv => reserv.Ident) : [this.planningService.idReserv],
      IdLearner: apprenant.strIdent,
      IdStage: this.stageService.Stage.Ident,
      CodePresence: value
    };
    this.savingPresence = true;
    document.getElementsByTagName('body')[0].classList.add('q-wait');
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SAVE_PRESENCE`, model).subscribe(
      (datas: QResult<Array<ReservationPlanning>>) => {
        if (!datas.HasError) {
          // Mise à jour de la réservation dans la liste
          datas.Value.forEach(data => {
            let reservToUpdate = this.planningService.ListeReservations.find(reserv => reserv.Ident == data.Ident);
            if (reservToUpdate) {
              reservToUpdate.Etat = data.Etat;
              reservToUpdate.NbNa = data.NbNa;
              reservToUpdate.NbPresent = data.NbPresent;
              reservToUpdate.NbAbs = data.NbAbs;
              reservToUpdate.NbAbsInj = data.NbAbsInj;
              reservToUpdate.NbPreinsc = data.NbPreinsc;
            }
          });

        }
        //this.planningService.ListeReservations = JSON.parse(JSON.stringify(this.planningService.ListeReservations));
        this.savingPresence = false;
        document.getElementsByTagName('body')[0].classList.remove('q-wait');
      });
  }

  public DeleteStgSignature(idPere: string, pMultiReservs: boolean, codeRelation: string, stg: Apprenant | null = null): void {
    this.deletingSignature = true;
    if (!stg) {
      this.reloadEmargementFormateur = true;
    }
    const idReservs = pMultiReservs ? this.ListReservChecked.map((reserv) => reserv.Ident) : [this.planningService.idReserv];
    idReservs.forEach(idFils => {
      this.http.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/signature/DELETE_SIGNATURE/${idPere}|${idFils}|${codeRelation}`).subscribe((data: EventsModel) => {
        if (!data.HasError) {
          if (stg) {
            stg.infoEmargement = '';
            stg.pathEmargement = '';
          }
          this.reloadEmargementFormateur = false;
        }
        this.deletingSignature = false;
      });
    });
  }

  // #endregion


  /**
   * Mise à jour de la liste des réservations sélectionnées
   **/
  SetListChecked(): void {
    this.ListReservChecked = this.planningService.ListeReservationsFilter.filter(reserv => reserv.IsSelected); // nnot read properties of undefined (reading 'IsSelected')
    // Changement d'état du bouton "tout sélectionner"
    let isIndeterminate = false;
    let firstReservSelected = this.planningService.ListeReservationsFilter.find(r => r == this.planningService.ListeReservationsFilter[0])?.IsSelected;
    if (firstReservSelected != undefined) {
      this.planningService.ListeReservationsFilter.forEach(reservation => {
        if (reservation.IsSelected != firstReservSelected) {
          isIndeterminate = true;
        }
      });
    }
    this.planningService.Filter.IndeterminateSelect = isIndeterminate;

  }

  /**
   * Fonction pour savoir s'il y a au moins une réservétion sélectionnée
   **/
  public HasReservSelected(): boolean {
    var sortedSelectedList: Array<ReservationPlanning> = this.planningService.sortedReservations.filter(reserv => reserv.IsSelected);
    var newArray: Array<ReservationPlanning> = new Array<ReservationPlanning>();
    for (var i = 0; i < sortedSelectedList.length; i++) {
      newArray = this.planningService.ListeReservationsFilter.map(item => (item.Ident == sortedSelectedList[i].Ident ? sortedSelectedList[i] : item));
    }
    return newArray.filter(reserv => reserv.IsSelected).length > 0;
  }

  /**
   * Fonction pour savoir s'il y a des réservations en court de création (ident = 0)
   **/
  public ShowSaveNewReserv(): boolean {
    return this.planningService.ListeReservations.filter(reserv => !reserv.Ident || reserv.Ident == '0').length > 0;
  }

  /**
   * Enregistrement du découpage (nouvelles réservations)
   **/
  public SaveNewReserv(): void {
    if (this.isLoading) {
      this.toast.showAlertToast('un découpage est déjà en cours.');
      return;
    }
    this.isLoading = true;
    const model: ReservationPlanningAndIdStage = {
      IdStage: this.stageService.Stage.Ident,
      reservations: this.planningService.ListeReservations
    }

    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/SAVE_RESERVS_ARRAY`, model).subscribe(
      (result: QResult<Array<ReservationPlanning>>) => {
        this.planningService.Filter.ShowOnlyNew = false;
        this.planningService.ListeReservations = result.Value;
        this.isLoading = false;

        //for (var i = 0; i < this.planningService.nbReservShowed; i++) {
        //    if (this.planningService.sortedReservations[i] != this.planningService.ListeReservationsFilter[i]) {
        //      this.planningService.sortedReservations[i] = this.planningService.ListeReservationsFilter[i];
        //    }
        //  }
        this.planningService.ShowOnlyNewReservState = false;
        this.planningService.OnRefreshDisplay();
      });
  }

  /**
   * Affectation de la réservation à mettre à jour à partir d'une réservation sélectionnée (pour que toutes les autres aient les mêmes infos à l'enregistrement)
   * value = ident|dateCourte|typeReserv pour pouvoir gérer les réservations temporaires sans ident
   **/
  public SetReservForUpdate(value: string): void {
    if (!value || value == '0') {
      this.InitReservForUpdate();
    }
    else {
      let strTemp = value.split('|');
      const ident = strTemp[0];
      const shortDate = strTemp[1];
      const typeReserv = strTemp[2];
      const reservSelected = this.ListReservChecked.find(reserv => reserv.Ident == ident && reserv.ShortDate == shortDate && reserv.TypeReserv == typeReserv);
      if (reservSelected) {
        this.ReservForUpdate = JSON.parse(JSON.stringify(reservSelected));
        // Affichage de toutes les modifications possibles (cequi est défini sur la réservation choisie)
        this.ReservForUpdate.ShowTrainer = reservSelected.Formateurs.length > 0;
        this.ReservForUpdate.ShowObject = this.AnyObjectSelected(reservSelected);
        this.ReservForUpdate.ShowLocation = !isEmptyStr(reservSelected.IdLieu) && reservSelected.IdLieu != '0' && reservSelected.IdLieu != '-1';
        this.ReservForUpdate.ShowOffice = !isEmptyStr(reservSelected.IdBureau) && reservSelected.IdBureau != '0' && reservSelected.IdBureau != '-1';
        this.ReservForUpdate.ShowDispo = !isEmptyStr(reservSelected.CodeDispo) && reservSelected.CodeDispo != '0' && reservSelected.CodeDispo != '-1';
      }
    }

  }

  /**
   * Fonction pour savoir si le bouton d'enregistrement des modifications des réservations peut être affiché ou non
   **/
  public CanUpdate(): boolean {
    return (this.ReservForUpdate.Titre != undefined && this.ReservForUpdate.Titre != '') || this.ReservForUpdate.ShowTrainer || this.ReservForUpdate.ShowObject || this.ReservForUpdate.ShowLocation || this.ReservForUpdate.ShowOffice || this.ReservForUpdate.ShowDispo;
  }

  /**
   * Mise à jour des réservations sélectionnées
   **/
  public SaveListReserv(): void {
    // liste des réservations qui vont être mise à jour en base (ident != 0)
    let listReservToUpdate: Array<ReservationPlanning> = [];
    for (var i = 0; i < this.planningService.ListeReservations.length; i++) {
      if (this.planningService.ListeReservations[i].IsSelected) {
        // Si c'est une réservation temporaire -> modification manuellement dans la liste
        if (!this.planningService.ListeReservations[i].Ident || this.planningService.ListeReservations[i].Ident == '0') {
          this.ModifyReservTemp(this.planningService.ListeReservations[i]);
        }
        else {
          // Ajout à la liste qui va être modifiée en base
          listReservToUpdate.push(this.planningService.ListeReservations[i]);
        }
      }
    }
    if (listReservToUpdate.length > 0) {
      const model: PlanningFormationModel = new PlanningFormationModel();
      model.ListeReservations = listReservToUpdate;
      model.ReservForUpdate = this.ReservForUpdate;
      model.IdStage = this.stageService.Stage.Ident;
      this.editLoading = true;
      this.http.postHttp<QResult<PlanningFormationModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/UPDATE_RESERVATIONS`, model).subscribe(
        (result: QResult<PlanningFormationModel>) => {
          if (!result.HasError) {
            this.toast.showSuccessToast('Les réservations ont bien été modifiées');
            const tempsReservations = this.planningService.ListeReservations.filter(reservation => !reservation.Ident || reservation.Ident == "0");
            this.planningService.ListeReservations = tempsReservations.concat(result.Value.ListeReservations);
            this.editLoading = false;
            this.planningService.isSelectAll = false;
            this.planningService.Filter.IndeterminateSelect = false;
          }
        });
    }

  }

  /**
   * Liste des elements selectionnés pour le tooltip
   **/
  public GetListFormateur(formateurs: Array<Person>): string {
    let strForm: string = '';
    if (formateurs) {
      formateurs.forEach((form: Person) => {
        strForm = form && form.Id ? strForm ? `${strForm}\n${form.Firstname} ${form.Lastname}` : `${form.Firstname} ${form.Lastname}` : strForm;
      });
    }
    return strForm;
  }

  // #region Private

  /**
   * Modification d'une réservation en fonction de la réservation à mettre à jour
   * @param reserv
   */
  private ModifyReservTemp(reserv: ReservationPlanning): void {
    // formateur
    if (this.ReservForUpdate.ShowTrainer) {
      reserv.Formateurs = this.ReservForUpdate.Formateurs;
    }
    // objets
    if (this.ReservForUpdate.ShowObject) {
      reserv.ObjetReserves = this.ReservForUpdate.ObjetReserves;
    }
    // lieu de convocation
    if (this.ReservForUpdate.ShowLocation) {
      reserv.IdLieu = this.ReservForUpdate.IdLieu;
    }
    // bureau
    if (this.ReservForUpdate.ShowOffice) {
      reserv.IdBureau = this.ReservForUpdate.IdBureau;
    }
    // disponibilité
    if (this.ReservForUpdate.ShowDispo) {
      reserv.CodeDispo = this.ReservForUpdate.CodeDispo;
    }
  }

  /**
   * Fermeture de toutes les fenêtres d'édition pour toutes les réservations
   **/
  private closeAllEdit(): void {
    this.planningService.ListeReservationsFilter.forEach((reserv: ReservationPlanning) => {
      reserv.IsEdit = false;
    });
  }

  /**
   * Test si les apprenants ont tous la même valeur de présence pour cocher par défaut le radio GlobalPresence
   **/
  private initGlobalPresence(pGlobalPresence: string): void {
    const lstTypePresence: Array<string> = ['0', 'PI', 'P', 'A', 'AI'];
    lstTypePresence.forEach((typePresence: string) => {
      if (!this.listApprenant.some(appr => appr.presence != typePresence)) {
        pGlobalPresence = typePresence;
      }
    });
  }
  // #region private

}
